import { useEffect, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { AuthForm } from "../components/auth-form";
import { AuthShell } from "../components/auth-shell";
import { useAuthCtx } from "../lib/auth-provider";
import { decideAndRedirect } from "../lib/post-auth";

export function LoginPage() {
  const nav = useNavigate();
  const [params] = useSearchParams();
  const { user, loading } = useAuthCtx();
  const { t } = useTranslation();
  // Store the i18n KEY (not the translated string) so the toggle EN|ES
  // re-renders the error in the current language.
  const [ssoErrorKey, setSsoErrorKey] = useState<string | null>(null);

  const signupHref = `/signup${params.toString() ? "?" + params.toString() : ""}`;

  useEffect(() => {
    if (!loading && user) {
      decideAndRedirect({
        user,
        params,
        nav,
        onSsoError: () => setSsoErrorKey("auth.errors.ssoMintFailed"),
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading, user]);

  if (loading) return null;
  // Hide the login form once authenticated; if SSO failed for a logged-in user,
  // render the AuthShell anyway so the error is visible.
  if (user && !ssoErrorKey) return null;

  return (
    <AuthShell
      formTitle={t("auth.shell.loginTitle")}
      formSub={t("auth.shell.loginSub")}
      footer={<>{t("auth.shell.loginFooter")}<Link to={signupHref}>{t("auth.shell.loginFooterLink")}</Link></>}
    >
      {ssoErrorKey && (
        <div className="acx__alert acx__alert--error" style={{ marginBottom: "1rem" }}>
          {t(ssoErrorKey)}
        </div>
      )}
      {!user && <AuthForm mode="login" onSuccess={() => { /* useEffect picks up */ }} />}
    </AuthShell>
  );
}
